import { CONSENT_CHANGED_EVENT } from './changeEvents'
import { clearUngrantedPurposeIdentifiers } from './clearWithdrawnIdentifiers'
import { readConsentState } from './deviceState'
import { reloadPage } from './reloadPage'

// Cookies do not emit storage events. Broadcast promptly, and check on focus and
// periodically for browsers without BroadcastChannel and for consent expiry.
export function synchroniseConsent() {
  let previous = JSON.stringify(readConsentState())
  let reloading = false
  let channel: BroadcastChannel | undefined
  try {
    channel = new BroadcastChannel('le-consent')
  } catch {
    // Polling and focus checks still work when messaging is unavailable.
  }

  const check = () => {
    const current = readConsentState()
    if (reloading || JSON.stringify(current) === previous) return
    reloading = true
    try {
      clearUngrantedPurposeIdentifiers(current?.purposes ?? [])
    } finally {
      reloadPage()
    }
  }
  const publish = () => {
    // The saving tab applies its choice through the consent dialog.
    previous = JSON.stringify(readConsentState())
    try {
      channel?.postMessage('changed')
    } catch {
      // Other tabs will discover the cookie change on their next check.
    }
  }
  if (channel) channel.onmessage = check
  window.addEventListener(CONSENT_CHANGED_EVENT, publish)
  window.addEventListener('focus', check)
  document.addEventListener('visibilitychange', check)
  const interval = window.setInterval(check, 1000)

  return () => {
    channel?.close()
    window.clearInterval(interval)
    window.removeEventListener(CONSENT_CHANGED_EVENT, publish)
    window.removeEventListener('focus', check)
    document.removeEventListener('visibilitychange', check)
  }
}
